module.exports = __webpack_public_path__ + "static/img/arinkel-2.9293eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/arinkel-2.jpg
// module id = 9yxm
// module chunks = 1